import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Invoice, InvoiceLight } from "src/app/backend/models/invoice/invoice";
import { dateUtil } from "src/app/support/date-util";

export async function getPaymentTerms(): Promise<
  Array<{ display: string; value: string }>
> {
  return [
    {
      value: "30",
      display: sntTranslate(marker("+30 giorni"))
    },
    {
      value: "60",
      display: sntTranslate(marker("+60 giorni"))
    },
    {
      value: "90",
      display: sntTranslate(marker("+90 giorni"))
    },
    {
      value: "120",
      display: sntTranslate(marker("+120 giorni"))
    }
  ];
}

export function getInvoiceName({
  invoice,
  omitDate,
  omitFileExtension,
  short
}: {
  invoice: InvoiceLight;
  omitDate?: boolean;
  omitFileExtension?: boolean;
  short?: boolean;
}): string {
  return getInvoiceFileName(invoice, omitDate, omitFileExtension);
}

export function getPaymentReceiptFileName(invoice: InvoiceLight): string {
  return `${sntTranslate(marker("Ricevuta di pagamento"))} - ${getInvoiceFileName(invoice, false, true)}.pdf`;
}

export function getInvoiceFileName(
  invoice: InvoiceLight,
  omitDate: boolean = false,
  omitFileExtension: boolean = false,
  short: boolean = false
): string {
  let text = "";

  if (invoice.isDraft) {
    text = `${sntTranslate(marker("Notula"))}`;
  } else {
    text = `${sntTranslate(short ? marker("FT.") : marker("Fattura n."))} ${invoice.number}`;
  }

  const date = invoice.emittedAt || invoice.createdAt || undefined;

  if (date && !omitDate) {
    text = `${text} ${sntTranslate(marker("del"))} ${dateUtil(date).format(
      "DD/MM/YYYY"
    )}`;
  }

  return omitFileExtension ? text : `${text}.pdf`;
}
